import React, { useEffect, useState } from 'react';
import { useData } from '../../../contexts';
import { DownloadButton } from '../../DownloadButton/DownloadButton';
// import { Tooltip, TooltipTrigger, TooltipContent } from '../../Tooltip/Tooltip';
import { Grid } from '@mui/material';
import { MdClose, MdHelpOutline } from 'react-icons/md';
import { InsightsBenchmarkTable } from './InsightsBenchmarkTable';
import { BarChartDeltaHighlightAndZoomHorizontal } from '../../BarChart/BarChartDeltaHighlightAndZoomHorizontal';
import { SelectionPanel } from '../InsightsSynthesisSelectionPanel/SelectionMenuComponents/SelectionPanel';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../Tooltip/Tooltip';
import { InfoPanelOther } from '../../InfoPanelCluster/InfoPanelOther';

export const InsightsBenchmark = (props: any) => {
  const {
    data: propsData,
    pathInteractieveTool,
    toggled,
    open,
    setOpen,
    themas,
    indicatorThema,
    gemeenteLijst,
    benchmarkLijst,
    setBenchmarkLijst,
    d_ruimte,
    highlightedRow,
    setHighlightedRow,
    tableHighlightedRow,
    setTableHighlightedRow,
  } = props;
  const {
    selectedGemeente,
    selectedTopic,
    selectedBenchmarks,
    interfaceColor,
    barColors,
    locale,
    isZoomedInsights,
    setIsZoomedInsights,
    zoomFilters,
    setZoomFilters,
    deltaColors,
    selectedIndicatorsInzichten,
  } = useData();

  const id = 'Benchmarking';

  const xVar = 'deltaGemeenteBench';
  const yVar = 'displayOrder';

  const [dataTable, setDataTable] = useState(propsData);
  const [resetZoom, setResetZoom] = useState(false);
  const [incomingData, setIncomingData] = useState([]) as any[];
  const [initialState, setInitialState] = useState({
    data: incomingData,
    left: 'dataMin',
    right: 'dataMax',
    refAreaLeft: '',
    refAreaRight: '',
    top: 'dataMax',
    bottom: 'dataMin',
    animation: true,
  }) as any[];

  const handleOpen = () => setOpen(true);

  useEffect(() => {
    toggled && handleOpen();
  }, [toggled]);

  const [zoomGraph, setZoomGraph] = useState(initialState);

  const zoomOut = (pageId) => {
    const newTableData = propsData;

    setIsZoomedInsights(false);

    const unique = [...new Set(newTableData.map((d: any) => d.id))];
    setZoomFilters((prev: any) => ({ ...prev, [pageId]: unique }));
    setResetZoom(true);
    setZoomGraph((prev: any) => ({
      ...prev,
      data: newTableData,
      refAreaLeft: '',
      refAreaRight: '',
      left: 'dataMin-1',
      right: 'dataMax+1',
      top: 'dataMax',
      bottom: 'dataMin',
    }));
  };

  const resetData = () => {
    let tmpData = structuredClone(propsData).sort(
      (a: any, b: any) => b[xVar] - a[xVar],
    );

    tmpData.map((d: any, i: number) => {
      d.displayOrder = i + 1;
      return d;
    });

    setInitialState({
      data: tmpData,
      left: 'dataMin',
      right: 'dataMax',
      refAreaLeft: '',
      refAreaRight: '',
      top: 'dataMax+1',
      bottom: 'dataMin-1',
      animation: true,
    });

    setDataTable(propsData);
    setIncomingData(tmpData);
  };

  useEffect(() => {
    resetData();
    zoomOut(id);
  }, [
    propsData,
    setIncomingData,
    setInitialState,
    selectedIndicatorsInzichten,
  ]);

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      setHighlightedRow(null);
      let formattedTick = locale.format(',.1%')(payload[0].value);
      let sign = payload[0].value > 0 ? '+' : '';
      let newValue = sign + formattedTick;

      setTableHighlightedRow(payload[0].payload.id);

      return (
        <div
          style={{
            backgroundColor: 'white',
            padding: 8,
            border: '1px solid #aaa',
            maxWidth: '400px',
          }}
        >
          <p>{payload[0]?.payload?.indicator}</p>
          <ul>
            <li>
              Waarde {selectedGemeente.ruimte}:{' '}
              {locale.format(payload[0].payload['d3format']) !== undefined
                ? locale.format(payload[0].payload['d3format'])(
                    payload[0].payload['value'] !== null
                      ? payload[0].payload['value']
                      : '-',
                  )
                : payload[0].payload['value']}
            </li>
            <li>
              Waarde {selectedBenchmarks[0].ruimte}:{' '}
              {locale.format(payload[0].payload['d3format']) !== undefined
                ? locale.format(payload[0].payload['d3format'])(
                    payload[0].payload['valueBench'],
                  )
                : payload[0].payload['valueBench']}
            </li>
            <li>Relatief verschil: {newValue}</li>
          </ul>
        </div>
      );
    }
  };

  return (
    <Grid container style={{ padding: '16px' }}>
      <Grid item xs={12}>
        <div
          className={'vl-typography'}
          style={{ paddingLeft: '8rem', float: 'left', width: '70%' }}
        >
          <h4 className="page-title">
            Hoe doet {selectedGemeente.label} het ten opzichte van de benchmark{' '}
            {selectedBenchmarks[0].label}?{' '}
          </h4>
          <p className="page-subtitle">
            Wat is het relatieve verschil tussen {selectedGemeente.label} en de
            benchmark {selectedBenchmarks[0].label} op een gekozen indicator?
          </p>
        </div>
        <div
          className={'vl-typography'}
          style={{
            float: 'right',
            // marginLeft: 'auto',
            marginRight: '36px',
            cursor: 'pointer',
            paddingRight: '8px',
            paddingLeft: '8px',
            backgroundColor: interfaceColor,
            borderRadius: 12,
            position: 'relative',
            top: '18px',
          }}
        >
          <p style={{ marginBottom: 0, color: 'white' }} onClick={handleOpen}>
            Pas je selectie aan
          </p>
          <SelectionPanel
            open={open}
            setOpen={setOpen}
            themas={themas}
            indicatorThema={indicatorThema}
            gemeenteLijst={gemeenteLijst}
            selectedGemeente={selectedGemeente}
            selectedBenchmarks={selectedBenchmarks}
            benchmarkLijst={benchmarkLijst}
            setBenchmarkLijst={setBenchmarkLijst}
            d_ruimte={d_ruimte}
          />
        </div>
        <div>
          <InfoPanelOther
            content={
              <>
                <p>
                  Voor elke indicator nemen we voor de gemeente en de benchmark
                  de meest recente meetwaarde. Vervolgens berekenen we het
                  relatieve verschil tussen deze twee waarden. De berekening is
                  als volgt:
                </p>

                <ul style={{ paddingLeft: 16 }}>
                  <li>
                    <span style={{ color: 'blue' }}>
                      • ( {selectedGemeente.label} (meest recente meetwaarde) -{' '}
                      {selectedBenchmarks[0].label} (meest recente meetwaarde) )
                      / {selectedBenchmarks[0].label} (meest recente meetwaarde)
                    </span>{' '}
                  </li>
                </ul>
                <br />
                <p>
                  Deze figuur toont voor elke indicator hoeveel groter of
                  kleiner de meest recente meetwaarde van{' '}
                  {selectedGemeente.label} is dan die van de benchmark{' '}
                  {selectedBenchmarks[0].label}, relatief uitgedrukt (als
                  percentage). We kiezen voor het relatieve verschil omdat je
                  dan voor verschillende indicatoren met verschillende eenheden
                  kan nagaan hoe {selectedGemeente.label} scoort ten opzichte
                  van de benchmark {selectedBenchmarks[0].label}.
                </p>
                <br />
                <p>Aandachtspunten:</p>

                <ul style={{ paddingLeft: 16 }}>
                  <li>
                    • Voor heel wat indicatoren zijn er niet voor alle 300
                    gemeenten of voor alle benchmarks data beschikbaar. Voor
                    deze indicatoren kunnen we bijgevolg geen relatief verschil
                    berekenen. Dit staat ook zo aangegeven in de tabel, en deze
                    indicatoren zijn ook niet zichtbaar in de figuur.
                  </li>
                </ul>
                <br />
                <p>
                  Wil je inzoomen binnen de figuur? Selecteer het gewenste
                  bereik van staafjes/indicatoren. Deze selectie van indicatoren
                  wordt vervolgens ook doorgetrokken naar de andere figuren op
                  de pagina.
                </p>
                <br />
                <p>
                  Wil je de tabel anders sorteren? Je kan de tabel sorteren op
                  elk van de kolommen. Standaard is de tabel gesorteerd op de
                  kolom ‘Relatief verschil’.
                </p>
              </>
            }
          />
        </div>
      </Grid>

      <Grid
        item
        xs={12}
        pl={5}
        pr={5}
        height={'88vh'}
        minHeight={'400px'}
        maxHeight={'88vh'}
        id={id}
        sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}
      >
        {incomingData !== undefined && incomingData.length > 0 ? (
          <Grid container sx={{ maxHeight: '100%' }}>
            <Grid
              item
              xs={12}
              sx={{
                height: '154px',
                maxHeight: '154px',
                paddingLeft: '36px',
                paddingRight: '36px',
                userSelect: 'none',
                fontSize: '0.8em',
              }}
            >
              <BarChartDeltaHighlightAndZoomHorizontal
                pageId={id}
                xAxisDataKey={xVar}
                yAxisDataKey={yVar}
                incomingData={incomingData}
                initialState={initialState}
                zoomGraph={zoomGraph}
                setZoomGraph={setZoomGraph}
                resetZoom={resetZoom}
                setResetZoom={setResetZoom}
                setIsZoomedInsights={setIsZoomedInsights}
                setDataTable={setDataTable}
                zoomFilters={zoomFilters}
                setZoomFilters={setZoomFilters}
                colors={deltaColors}
                locale={locale}
                CustomTooltip={CustomTooltip}
                highlightedRow={highlightedRow}
                setHighlightedRow={setHighlightedRow}
                tableHighlightedRow={tableHighlightedRow}
                setTableHighlightedRow={setTableHighlightedRow}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                height: '20px',
                maxHeight: '20px',
                paddingRight: '36px',
                paddingLeft: '100px',
              }}
            >
              <div
                style={{
                  whiteSpace: 'break-spaces',
                  fontSize: '13px',
                  paddingRight: '16px',
                }}
              >
                <ul>
                  {Object.keys(zoomFilters).map((d: any) => {
                    if (
                      zoomFilters[d].length !== 0 &&
                      zoomFilters[d].length !== incomingData.length
                    ) {
                      return (
                        <li
                          onClick={() => zoomOut(d)}
                          style={{
                            display: 'inline-block',
                            margin: 4,
                            marginTop: 8,
                            paddingLeft: 8,
                            paddingRight: 14,
                            backgroundColor: interfaceColor,
                            borderRadius: 24,
                            color: 'white',
                            cursor: 'pointer',
                            position: 'relative',
                            top: '-14px',
                          }}
                        >
                          {'Filter: ' + d}
                          <span
                            style={{
                              fontWeight: 'bold',
                              position: 'relative',
                              top: 3,
                              left: 8,
                            }}
                          >
                            <MdClose />
                          </span>
                        </li>
                      );
                    }
                  })}
                </ul>
              </div>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                height: '60vh',
                maxHeight: '60vh',
                paddingRight: '36px',
                paddingLeft: '60px',
              }}
            >
              <InsightsBenchmarkTable
                data={dataTable}
                pathInteractieveTool={pathInteractieveTool}
                setHighlightedRow={setHighlightedRow}
                highlightedRow={highlightedRow}
                tableHighlightedRow={tableHighlightedRow}
                setTableHighlightedRow={setTableHighlightedRow}
              />
            </Grid>
          </Grid>
        ) : (
          <Grid container style={{ padding: '16px' }}>
            <Grid
              item
              xs={12}
              pl={5}
              pr={5}
              height={'60vh'}
              minHeight={'400px'}
              sx={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              {' '}
              <p>Geen data gevonden</p>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
